import React, { useState, useEffect, useMemo } from "react";
import { Select } from "antd";
import { debounce } from "lodash";
import FloatLabel from "../FloatingLabel";

const { Option } = Select;

const SelectComponent = (props) => {
  const { item, field, formData, form, placeholder, search, readOnly } = props;
  const { code, fieldOptions } = item;
  const { onBlur, onChange, value, name } = field;

  const { setFieldValue, values, handleBlur, validateForm } = form;

  const handleDebounceValidateFn = () => {
    validateForm();
  };

  const debounceValidateFn = React.useCallback(debounce(handleDebounceValidateFn, 200), []);

  const _value = useMemo(()=> {
    return fieldOptions?.find(fieldOption => fieldOption.optionId === value)?.optionValue ?? value;
  }, [value])

  return (
    <>
      <FloatLabel label={placeholder} name={name} value={value}>
        <Select
          className={readOnly ? "readonly" : ""}
          disabled={readOnly ? true : false}
          name={name}
          style={{
            width: "100%",
          }}
          // size="large"
          bordered
          showSearch={search}
          allowClear
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(selectValues, selectValuesOptions) => {
            let selectValuesOptionName = "";
            // console.log(selectValues);
            if (selectValues != null) {
              selectValuesOptionName = selectValuesOptions.name;
              setFieldValue(name, selectValues);
              setFieldValue(name + "_name_", selectValuesOptionName);
            } else {
              setFieldValue(name, "");
              setFieldValue(name + "_name_", "");
            }

            if (code == "ResCity" || code == "ResPIN") {
              let cloneData = false;
              const dependedField = formData.filter(
                (formItem) => formItem.code == "PermAddrSameAsResAddr"
              );
              if (dependedField && dependedField.length > 0) {
                if (values[`${dependedField[0].id}`]) {
                  cloneData = true;
                }
              }

              if (cloneData) {
                if (code == "ResCity") {
                  const dependedField = formData.filter(
                    (formItem) => formItem.code == "PermCity"
                  );
                  if (dependedField && dependedField.length > 0) {
                    setFieldValue(
                      `${dependedField[0].id}`,
                      selectValuesOptionName
                    );
                  }
                }

                if (code == "ResPIN") {
                  const dependedField = formData.filter(
                    (formItem) => formItem.code == "PermPin"
                  );
                  if (dependedField && dependedField.length > 0) {
                    setFieldValue(
                      `${dependedField[0].id}`,
                      selectValuesOptionName
                    );
                  }
                }
              }
            }

            if (code == "EmploymentType") {
              const dependedField = formData.filter(
                (formItem) => formItem.code == "NameOfCompanyBusiness"
              );
              if (dependedField && dependedField.length > 0 && selectValuesOptionName == 'Self Employed' ) {
                if (selectValues) {
                  setFieldValue(
                    dependedField[0].id,
                    // selectValuesOptions.name
                    "Others"
                  );
                } else {
                  setFieldValue(dependedField[0].id, "");
                }
              }
            }

            if (code == "EmploymentType") {
              const dependedField = formData.filter(
                (formItem) => formItem.code == "designation"
              );
              if (dependedField && dependedField.length > 0 && selectValuesOptionName == 'Self Employed' ) {
                if (selectValues) {
                  setFieldValue(
                    dependedField[0].id,
                    // selectValuesOptions.name
                    "Others"
                  );
                } else {
                  setFieldValue(dependedField[0].id, "");
                }
              }
            }

            if (code == "IsExtngScbCust") {
              if (selectValues == "no" || selectValues == false) {
                const dependedField = formData.filter(
                  (formItem) => formItem.code == "CustReltnType"
                );
                if (dependedField && dependedField.length > 0) {
                  setFieldValue(`${dependedField[0].id}`, "");
                }
              }
            }
          }}
          onClear={() => {
            debounceValidateFn();
          }}
          onSelect={() => {
            debounceValidateFn();
          }}
          onBlur={handleBlur(name)}
          value={_value || ""}
        >
          {fieldOptions.map((fieldOption, i) => {
            return (
              <Option
                value={fieldOption.optionId}
                key={name + "@" + fieldOption.optionId + "@" + i}
                name={fieldOption.optionValue}
              >
                {fieldOption.optionValue}
              </Option>
            );
          })}
        </Select>
      </FloatLabel>
    </>
  );
};

export default SelectComponent;
